'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Close = require('../../../node_modules/@material-ui/icons/Close.js');
var Grid = require('../../Layout/Grid/Grid.js');
var Typography = require('../../DataDisplay/Typography/Typography.js');
var IconButton = require('../../Inputs/Buttons/IconButton.js');
var DialogTitle$1 = require('../../../node_modules/@material-ui/core/esm/DialogTitle/DialogTitle.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DialogTitle = function DialogTitle(_ref) {
  var children = _ref.children,
      disableTypography = _ref.disableTypography,
      onClose = _ref.onClose,
      props = objectWithoutProperties(_ref, ["children", "disableTypography", "onClose"]);

  return React__default["default"].createElement(DialogTitle$1["default"], _objectSpread({
    disableTypography: true
  }, props), disableTypography ? children : React__default["default"].createElement(Grid, {
    container: true,
    justify: "space-between",
    wrap: "nowrap"
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: "auto"
  }, React__default["default"].createElement(Typography, {
    variant: 'h2',
    color: 'textPrimary'
  }, children)), onClose && React__default["default"].createElement(Grid, {
    item: true,
    xs: "auto"
  }, React__default["default"].createElement(IconButton, {
    "aria-label": "close",
    onClick: onClose
  }, React__default["default"].createElement(Close, null)))));
};

module.exports = DialogTitle;
